import React, { useEffect, useState, useContext } from 'react'
import {
    CognitoIdentityProviderClient,
    ForgotPasswordCommand
} from "@aws-sdk/client-cognito-identity-provider"
import CloudformationOutputs from '../CloudformationOutputs.json'
import { GlobalContext } from '../GlobalContext'
import { subscribe } from "../utils/pubsub"
import Spinner from "../ui-elements/Spinner"
import Button from '../formfields/Button'
import RedAlert from '../ui-elements/RedAlert'
import Modal from '../ui-elements/Modal'
import { useParams } from 'react-router-dom'
import Password from './auth_formfields/Password'
import Text from './auth_formfields/Text'
import ForgotPasswordCodeForm from './ForgotPasswordCodeForm'
import ForgotPasswordForm from './ForgotPasswordForm'

type Props = {

}


function ForgotPassword({
}: Props) {

    const {

    } = useContext(GlobalContext)


    const [forgotPasswordEmail, setForgotPasswordEmail] = useState<string>('')



    return <div className={`w-full flex flex-col gap-4`}>

        {forgotPasswordEmail ? 
        <ForgotPasswordCodeForm
            forgotPasswordEmail={forgotPasswordEmail}
            setForgotPasswordEmail={setForgotPasswordEmail}
        />: 
        <ForgotPasswordForm
            forgotPasswordEmail={forgotPasswordEmail}
            setForgotPasswordEmail={setForgotPasswordEmail}
        />}

    </div>
}
export default ForgotPassword